/**
    * @description      :
    * @author           :
    * @group            :
    * @created          : 25/08/2021 - 15:49:27
    *
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 25/08/2021
    * - Author          :
    * - Modification    :
**/
import * as React from "react"

const NovaMatriz = (props) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 1H3a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V3a2 2 0 00-2-2z"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 5H5v9h3V5zM15 5h-3v5h3V5z"
        stroke="#fff"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default React.memo(NovaMatriz)
